<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
  #app {
    color: #333;
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue